/* eslint-disable no-restricted-globals */
/* eslint-disable no-restricted-syntax */
/* eslint-disable camelcase */
import moment from 'moment';
import history from '../history';
import cookieLib from '../../helpers/cookieLib';

export const takeToDashboard = () => {
  const cid = cookieLib.getCookieByKey('cid');
  const token = cookieLib.getCookieByKey('token');
  if (cid && token) {
    history.push('/dashboard');
  }
};

export const perfectClone = input => {
  if (
    input === null ||
    typeof input !== 'object' ||
    !isNaN(Date.parse(input))
  ) {
    return input;
  }
  const output = Array.isArray(input) ? [] : {};
  for (const key of Object.keys(input)) {
    output[key] = perfectClone(input[key]);
  }

  return output;
};

export const isMobile = () => {
  let mobile = false;
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/iPhone/i)
  ) {
    mobile = true;
  }
  return mobile;
};

export const invoiceScheduleAfterPaymentTime = (date = new Date()) => {
  // function to check GMT Time before 10.30 AM
  const paymentTime = moment('10.30am', 'hh:mma'); // Payment Time
  const invoiceCreationTime = moment.utc().format('hh:mma'); // GMT Time for invoice creation
  if (moment(date).isBefore(new Date(), 'day')) {
    return true;
  } else if (moment(date).isSame(new Date(), 'day')) {
    return (
      new Date(moment(invoiceCreationTime, 'hh:mma').toDate()).getTime() >=
      new Date(paymentTime.toDate()).getTime()
    );
  }
  return false;
};

export const scrollTable = () => {
  var element = document.querySelector('.ct-table-container');
  if (!element) {
    console.error("Element not found.");
    return;
  }
  element.scrollLeft = 0;
}
